import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TJ2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TJ2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_692)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V18H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V6H24V0H0Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12V18H24V12H0Z"
          fill="#409100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0151 6.47224L11.5717 6.78553L11.7281 6.26054L11.2977 5.92917L11.8378 5.91799L12.0151 5.3999L12.1925 5.91799L12.7325 5.92917L12.3021 6.26054L12.4585 6.78553L12.0151 6.47224ZM10.1422 6.93184L9.69883 7.24513L9.85525 6.72013L9.4248 6.38876L9.96487 6.37759L10.1422 5.8595L10.3196 6.37759L10.8596 6.38876L10.4292 6.72013L10.5856 7.24513L10.1422 6.93184ZM8.24223 8.62382L8.68562 8.31053L9.129 8.62382L8.97258 8.09882L9.40303 7.76745L8.86297 7.75628L8.68562 7.23819L8.50826 7.75628L7.9682 7.76745L8.39865 8.09882L8.24223 8.62382ZM8.21742 10.0977L7.77403 10.411L7.93045 9.88603L7.5 9.55465L8.04006 9.54348L8.21742 9.02539L8.39477 9.54348L8.93483 9.55465L8.50438 9.88603L8.6608 10.411L8.21742 10.0977ZM15.3173 10.411L15.7607 10.0977L16.2041 10.411L16.0477 9.88603L16.4781 9.55465L15.9381 9.54348L15.7607 9.02539L15.5834 9.54348L15.0433 9.55465L15.4738 9.88603L15.3173 10.411ZM15.1885 8.31053L14.7451 8.62382L14.9015 8.09882L14.4711 7.76745L15.0112 7.75628L15.1885 7.23819L15.3659 7.75628L15.9059 7.76745L15.4755 8.09882L15.6319 8.62382L15.1885 8.31053ZM13.3103 7.24513L13.7537 6.93184L14.1971 7.24513L14.0407 6.72013L14.4711 6.38876L13.9311 6.37759L13.7537 5.8595L13.5763 6.37759L13.0363 6.38876L13.4667 6.72013L13.3103 7.24513ZM9.5005 12.5658L9.36225 12.0735C10.1273 11.8665 11.0056 11.7635 11.9973 11.7635C12.9891 11.7635 13.8674 11.8665 14.6324 12.0735L14.4942 12.5658C13.7771 12.3718 12.9447 12.2742 11.9973 12.2742C11.0499 12.2742 10.2176 12.3718 9.5005 12.5658ZM10.4479 11.7764C10.1427 11.8283 9.89307 11.5332 9.89307 11.5332L10.1959 11.4081C10.1863 11.1982 10.3129 11.068 10.3129 11.068C10.4154 11.1152 10.5552 11.373 10.5552 11.373H10.8297C10.8297 11.373 10.7532 11.7246 10.4479 11.7764ZM14.0551 11.5842C14.0551 11.5842 13.8054 11.8793 13.5002 11.8274C13.195 11.7756 13.1185 11.424 13.1185 11.424H13.393C13.393 11.424 13.5328 11.1662 13.6352 11.119C13.6352 11.119 13.7618 11.2492 13.7522 11.4591L14.0551 11.5842ZM11.959 11.6829C11.6496 11.6917 11.4434 11.3648 11.4434 11.3648L11.7607 11.2831C11.7804 11.0738 11.9239 10.9626 11.9239 10.9626C12.0188 11.0235 12.1213 11.2983 12.1213 11.2983L12.3932 11.3365C12.3932 11.3365 12.2685 11.674 11.959 11.6829Z"
          fill="#FFBB00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.969 10.2741C11.969 10.2741 11.6172 11.079 11.0632 11.1413C10.5092 11.2035 10.2279 10.6835 10.2279 10.6835C10.2279 10.6835 10.1916 11.2243 9.53366 11.4328C8.87574 11.6412 8.5293 10.8083 8.5293 10.8083C8.5293 10.8083 8.87182 11.1147 9.40308 10.9812C9.93433 10.8477 10.144 10.3546 10.144 10.3546C10.144 10.3546 10.5372 10.8687 11.0632 10.6116C11.5893 10.3546 11.8803 10.0405 11.8803 9.7391V8.83773C11.8803 8.83773 11.7446 8.604 11.5091 8.604C11.2737 8.604 11.208 8.7697 11.208 8.7697C11.208 8.7697 11.1161 7.83182 11.963 7.77398L11.963 7.77173L11.9863 7.77263L12.0097 7.77173L12.0096 7.77398C12.8566 7.83182 12.7646 8.7697 12.7646 8.7697C12.7646 8.7697 12.6989 8.604 12.4635 8.604C12.2281 8.604 12.0924 8.83773 12.0924 8.83773V9.7391C12.0924 10.0405 12.3834 10.3546 12.9094 10.6116C13.4355 10.8687 13.8286 10.3546 13.8286 10.3546C13.8286 10.3546 14.0383 10.8477 14.5696 10.9812C15.1008 11.1147 15.4434 10.8083 15.4434 10.8083C15.4434 10.8083 15.0969 11.6412 14.439 11.4328C13.7811 11.2243 13.7448 10.6835 13.7448 10.6835C13.7448 10.6835 13.4634 11.2035 12.9094 11.1413C12.3554 11.079 12.0037 10.2741 12.0037 10.2741L11.9863 9.20603L11.969 10.2741ZM11.9611 8.02655C11.5705 8.02655 11.4913 8.35723 11.4913 8.35723C11.8353 8.35723 11.9611 8.50715 11.9611 8.50715C11.9611 8.50715 12.2157 8.35723 12.4721 8.35723C12.4721 8.35723 12.3517 8.02655 11.9611 8.02655Z"
          fill="#FFBB00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_692">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TJ2418Icon;
